export default theme => ({
    appBar: {
      position: 'relative',
    },
    layout: {
      width: 'auto',
      marginLeft: 0,
      marginRight:0 ,
      padding:0,
      [theme.breakpoints.up(900 + theme.spacing(2) * 2)]: {
        width: 900,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    paper: {
      marginTop: 0,
      marginBottom: 0,
      padding: theme.spacing(2),
      [theme.breakpoints.up(900 + theme.spacing(3) * 2)]: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        padding: theme.spacing(3),
      },
    },
    stepper: {
      padding: `${theme.spacing(3)}px 0 ${theme.spacing(5)}px`,
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    avatar: {
      //margin: theme.spacing(1),
      backgroundColor: '#fff',
      width:'100px',
      height:'100px',
      margin: 'auto'
    },
  });